class DeleteInformationPartActions {
    items = [];
    menuItems= [];

    beforeResend = null;
    afterResend = null;

    constructor(data) {
        if (data.status !== 'new' && data.fileId !== null) {
            this.items.push({
                label: 'Скачать файл',
                icon: 'pi pi-fw pi-download',
                command: () => this.download(data.id)
            });
        }

        this.menuItems = this.items.filter((item) => item.viewOnly !== true);
    }

    download(id) {
        window.open(`/download/delete_information_part/${id}`, '_blank');
    }

    getItems() {
        return this.items;
    }

    getMenuItems() {
        return this.menuItems;
    }
}

export default DeleteInformationPartActions;